import React, { FC, useState } from "react";
import { RawMaterialT } from "../../../models/models";
import { A, Span } from "../../Text/Text";
import Icon from "../../Icon/Icon";
import { copyText } from "../../../utils/helpers/copyText";
import { RoutesE } from "../../../routes/routesData";
import Tooltip from "../../Tooltip/Tooltip";
import { isMobileOrTablet } from "../../../utils/helpers/mediaQueries";
import { IconColorE } from "../../../models/enums";
import { clss } from "../../../utils/helpers/styleHelpers";
import { useAppSelector } from "../../../store/hooks";
import { selectDirection } from "../../../store/selectors/appSelectors";

import styles from "./styles.module.scss";

type RawMaterialRowPropTypes = {
  data: RawMaterialT;
  index: number;
};

const RawMaterialRow: FC<RawMaterialRowPropTypes> = (props) => {
  const {
    data: { JumbomailURL, ContactName, EmailAddress, PhoneNumber, Comments },
    index,
  } = props;
  const [showActions, setShowActions] = useState(false);
  const isCampaignPage = window.location.pathname.includes(RoutesE.CAMPAIGNS);
  const [showMore, setShowMore] = useState(!isMobileOrTablet());
  const dir = useAppSelector(selectDirection);

  const handleCopy = () => {
    copyText(JumbomailURL);
  };

  const handleDownload = (e) => {
    window.open(JumbomailURL, "_blank");
  };

  const handleURLClick = (e) => {
    e.preventDefault();
  };

  const handleShowMore = () => {
    setShowMore((prev) => !prev);
  };

  return (
    <li className={styles.wrapper}>
      <span>
        <a href={JumbomailURL} target="_blank" className={styles.galleryLink}>
          #{index + 1} <Span>Gallery link</Span>
        </a>
        {isMobileOrTablet() && (
          <Icon
            name="selectFormArrow"
            onClick={handleShowMore}
            className={clss([
              styles.showMoreIcon,
              showMore ? styles.rotate180 : "",
            ])}
            color={IconColorE.DARK_GRAY}
          />
        )}
      </span>
      {(isMobileOrTablet() ? showMore : true) && (
        <>
          <span>{ContactName}</span>
          <span>{EmailAddress}</span>
          <span>{PhoneNumber}</span>
          <span className={styles.comment} title={Comments}>{Comments}</span>
        </>
      )}
      {isCampaignPage ? (
        <div className={styles.iconWrapper}>
          <Tooltip text="Download">
            <Icon
              name="download"
              onClick={handleDownload}
              className={styles.downloadIcon}
            />
          </Tooltip>
        </div>
      ) : (
        <div
          onMouseEnter={() => !isMobileOrTablet() && setShowActions(true)}
          onMouseLeave={() => !isMobileOrTablet() && setShowActions(false)}
          onClick={() => isMobileOrTablet() && setShowActions(prev => !prev)}
          className={clss([styles.actionListWrapper, styles.iconWrapper])}
        >
          <Icon name="menu" />
          {showActions && (
            <ul className={styles.actionList} dir={dir}>
              <li onClick={handleDownload}>
                <Icon name="download" />
                <A href={JumbomailURL} onClick={handleURLClick}>
                  Download
                </A>
              </li>
              <li onClick={handleCopy}>
                <Icon name="copy" />
                <Span>Copy link</Span>
              </li>
            </ul>
          )}
        </div>
      )}
    </li>
  );
};

export default RawMaterialRow;
